(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["feohwynn-compact-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fw-purchase-return')) {
    customElements.define('fw-purchase-return', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.fw-purchase-return');
        this.target = document.getElementById('price-' + this.dataset.section);
        this.update = () => {
          const form = document.getElementById('product-form-' + this.dataset.section);
          this.bar.hidden = !form || window.innerWidth > 767 || form.getBoundingClientRect().bottom >= 0;
        };
        this.observer = new IntersectionObserver(this.update);
        requestAnimationFrame(() => {
          const form = document.getElementById('product-form-' + this.dataset.section);
          if (form) this.observer.observe(form);
          this.update();
        });
        window.addEventListener('scroll', this.update, {passive:true});
        window.addEventListener('resize', this.update);
        this.querySelector('button').addEventListener('click', () => {
          if (!this.target) return;
          this.target.setAttribute('tabindex', '-1');
          this.target.focus({preventScroll:true});
          this.target.scrollIntoView({behavior:'instant', block:'start'});
          this.bar.hidden = true;
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
